import Swiper from 'swiper';
import {
    Navigation, Pagination, A11y, EffectFade, FreeMode
}             from 'swiper/modules';

/** @type {Object} Default accessibility labels */
const DEFAULT_A11Y = {
    prevSlideMessage        : 'Previous slide',
    nextSlideMessage        : 'Next slide',
    paginationBulletMessage : 'Go to slide {{index}}',
    firstSlideMessage       : 'First slide'
};

/**
 * Create a slider using Swiper library
 *
 * @param {HTMLElement} el - The element that contains the slider
 * @param {Object} config - Configuration options for the slider
 * @param {Object} [config.a11y] - Accessibility labels (merged with defaults)
 * @returns {Swiper|false} - The created Swiper instance or false if element not found
 */
function createSlider(el, config = {}) {
    if (!el) {
        return false;
    }

    const slider     = el.querySelector('.swiper');
    const next       = el.querySelector('.swiper-button-next');
    const prev       = el.querySelector('.swiper-button-prev');
    const pagination = el.querySelector('.swiper-pagination');

    const {
        a11y:a11yConfig,
        ...restConfig
    } = config;

    const settings = {
        modules               : [Navigation, Pagination, A11y, EffectFade, FreeMode],
        loop                  : false,
        slidesPerView         : 'auto',
        spaceBetween          : 0,
        watchSlidesVisibility : true,
        watchOverflow         : true,
        threshold             : 10,
        observer              : true,
        navigation            : {
            nextEl : next,
            prevEl : prev
        },
        a11y : {
            ...DEFAULT_A11Y,
            ...a11yConfig
        },
        pagination : {
            el        : pagination,
            type      : 'bullets',
            clickable : true
        },
        ...restConfig
    };

    return new Swiper(slider, settings);
}

export { createSlider };
